import React from 'react';
import { FormControl, FormControlLabel, FormGroup, Switch } from '@mui/material';

interface SwitchSeriesEventsProps {
  viewSeriesEvents: boolean;
  onChange: (value: boolean) => void;
}

export const SwitchSeriesEvents: React.FC<SwitchSeriesEventsProps> = ({
  viewSeriesEvents,
  onChange
}) => {
  return (
    <div className="event-grid-header-switch">
      <FormControl component="fieldset">
        <FormGroup aria-label="position" row>
          <FormControlLabel
            control={<Switch color="primary" checked={viewSeriesEvents} />}
            label="View series parents"
            labelPlacement="start"
            onChange={(event, value) => onChange(value)}
          />
        </FormGroup>
      </FormControl>
    </div>
  );
}; 